var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"statusLabel"},[_c('div',{staticClass:"status",class:{ off: _vm.status === 3|| _vm.status === 4, stop: _vm.status === 2 }},[_vm._v("\n    "+_vm._s(_vm.statusText)+"\n  ")]),_vm._v(" "),(_vm.status === 2)?_c('img',{staticClass:"error",attrs:{"src":"/static/img/choundiary/error.svg"}}):_vm._e()])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d765870a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/utvStore/components/ChounDiary/partials/StatusLabel.vue
// module id = null
// module chunks = 